import { TableColumnsType } from 'antd';
import { DataTypeReportICTSystems } from 'store/ducks/Reportings/types';

export const columns: TableColumnsType<DataTypeReportICTSystems> = [
  {
    title: 'Name of the financial entity',
    width: 100,
    dataIndex: 'entity_name',
    key: 'entity_name',
    fixed: 'left',
  },
  {
    title: 'ICT system description',
    width: 100,
    dataIndex: 'ict_system_name',
    key: 'ict_system_name',
  },
  {
    title: 'ICT Systems Valid from',
    width: 100,
    dataIndex: 'start_date',
    key: 'start_date',
  },
  {
    title: 'ICT Systems Valid to',
    width: 100,
    dataIndex: 'end_date',
    key: 'end_date',
  },
  {
    title: 'Function name',
    width: 100,
    dataIndex: 'function_name',
    key: 'function_name',
  },
  {
    title: 'ICT system name',
    width: 100,
    dataIndex: 'ict_system_description',
    key: 'ict_system_description',
  },
  {
    title: 'ICT service description',
    width: 100,
    dataIndex: 'ict_service_description',
    key: 'ict_service_description',
  },
  {
    title: 'Selected Date',
    width: 100,
    dataIndex: 'date',
    key: 'date',
  },
];
